<div class="page">
    <div id="USER-{{bulletin.user.code}}" *ngFor="let bulletin of period.bulletins; let iu = index" class="bulletin default" attr.style="height:{{height}}px; width:{{period.widthb}}%; margin-left: {{period.marginb}}%; margin-bottom: {{period.bmarginb}}%; ">
        <div class="entete {{(period.tools)? 'border': '' }}" attr.style="height:{{period.headHeight}}%;">
            <img attr.style="margin-top:{{period.logoMarginTop}}%;" attr.class="logo {{period.posImg}}" [height]="period.heightImg" [width]="period.widthImg" [src]="period.imageSrc || 'assets/logo/default.png'" alt="your image" />
            <div class="col-md-12">
                <div attr.style="text-align:{{period.textAlign}}">
                    <p class="nom_etab {{(period.tools)? 'border': '' }}" attr.style="width:{{period.titreWidth}}%; float:{{period.textPos}}; text-align:{{period.textAlign}}; font-size:{{period.titreFontSize}}px">{{period.etab?.etab_name}}</p>
                </div>
                <div attr.style=" text-align:{{period.textAlign}}; margin-top:{{period.detailsTextMt}}%;">
                    <p class="details_etab {{(period.tools)? 'border': '' }}" attr.style="width:{{period.detailWidth}}%; float:{{period.textPos}}; text-align:{{period.textAlign}} font-size:{{period.detailFontSize}}px">
                        <span *ngIf="period.etab?.phone" attr.style="font-size:{{period.detailFontSize}}px"> {{period.etab?.phone}} </span> |
                        <span *ngIf="period.etab?.email" attr.style="font-size:{{period.detailFontSize}}px"> {{period.etab?.email}} </span>
                        <span *ngIf="period.etab?.adresse" class="nom_adresse" attr.style="font-size:{{period.detailFontSize}}px">{{period.etab?.adresse}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="info {{(period.tools)? 'border': '' }}" attr.style="height:{{period.infoHeight}}%;">
            <div class="periode_name {{(period.tools)? 'border': '' }}" attr.style="font-size:{{period.titreInfoSizetext}}px">
                {{ period?.tbull }} {{period.name}}  {{ bulletin.code}}
            </div>
            <div class="period_info {{(period.tools)? 'border': '' }}">
                <div class="block-a {{(period.tools)? 'border': '' }}">
                    <div class="name-student {{(period.tools)? 'border': '' }}">
                        <b>{{ period?.fullname }}</b> {{bulletin?.user.name}}
                    </div>
                    <div class="class-period {{(period.tools)? 'border': '' }}">
                        <b>{{ period?.tclasse }}</b> {{period?.classe}} {{period?.etab?.domaine}} {{bulletin?.user.section}}
                    </div>
                </div>
                <div class="block-b {{(period.tools)? 'border': '' }}">
                    <div class=" code-student {{(period.tools)? 'border': '' }}">
                        {{bulletin?.user.code}}
                    </div>
                    <div class="year-period {{(period.tools)? 'border': '' }}">
                        {{period?.annee}}
                    </div>
                </div>
            </div>
        </div>
        <div class="note {{(period.tools)? 'border': '' }}" attr.style="height:{{period.resultHeight}}%;">
           <app-bodynote-gen
            [coef]="coef"
            [bulletin]="bulletin"
            [period]="period"
            [results]="bulletin.results"
           >
           </app-bodynote-gen>

            <table class="display my-table table-bordered colored" attr.style="width:{{ period.objWidth }}%; margin-top:{{period.margint}}%" *ngIf="getResultsNonCalc(bulletin).length>0">
                <thead>
                    <tr style="height: 10px; max-height: 10px;" attr.style="font-size:{{period.headTableTextsize}}px">
                        <th>{{ period?.tobj }}</th>
                        <th>{{ period?.tcoef }}</th>
                        <th *ngFor="let ps of period?.periods">
                            {{ ps.code}}
                        </th>
                        <th>{{ period?.tmg}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let o of getResultsNonCalc(bulletin); let i = index" style="max-height: 10px;">
                        <td>{{ o.cours.name}} </td>
                        <td>-</td>
                        <td class="note-td" *ngFor="let nt of o.note">
                            {{ nt }}
                        </td>
                        <td class="note-td">
                            {{ o?.note_total?.toFixed(0) }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="resText {{(period.tools)? 'border': '' }}" attr.style="margin-top:{{period.mentionMarginTop}}%;  height:{{period.mentionHeight}}%; width:{{ period.objWidth }}%;">
                <b>Mention:</b>
                <p *ngIf="bulletin?.total_note && getMoy((bulletin?.total_note?.toFixed(2)
                          / period?.periods.length).toFixed(2),bulletin.coef ,period?.etab?.moy_total)
                          < period.etab.moy_exc &&
                          getMoy((bulletin.total_note.toFixed(2) / period.periods.length).toFixed(2),bulletin.coef ,period?.etab?.moy_total)
                           >= period.etab.moy_pass " >{{period?.msg_reu}}</p>
                <p *ngIf=" getMoy((bulletin?.total_note?.toFixed(2) / period.periods.length).toFixed(2),bulletin.coef ,period?.etab?.moy_total) >= period.etab.moy_exc">{{period.msg_exc}}</p>
                <p *ngIf=" period.is_reprise &&  getMoy((bulletin.total_note.toFixed(2) / period.periods.length).toFixed(2),bulletin.coef ,period?.etab?.moy_total) < period.etab.moy_pass && getMoy((bulletin.total_note.toFixed(2) / period.periods.length).toFixed(2),bulletin.coef ,period?.etab?.moy_total)  >=period.etab.moy_rep ">{{period.msg_rep}}</p>
                <p *ngIf=" period.is_reprise &&  getMoy((bulletin.total_note.toFixed(2) / period.periods.length).toFixed(2),bulletin.coef,period?.etab?.moy_total) < period.etab.moy_rep ">{{period.msg_echec}}</p>
                <p *ngIf=" !period.is_reprise &&  getMoy((bulletin?.total_note?.toFixed(2) / period.periods.length).toFixed(2),bulletin.coef ,period?.etab?.moy_total) < period.etab.moy_pass ">{{period.msg_echec}}</p>
            </div>
        </div>

        <div class="col-md-12 {{(period.tools)? 'border': '' }}" attr.style="margin-top:{{period.smargin}}%;  height:{{period.signaHeight}}%;">
            <div class="mention" *ngIf="period.tut">
                <div class="ml-1 mt-2 signature prof">
                    {{ period.signa_ti }}
                </div>
                <div class="mt-2 signature parent mr-4">
                    {{ period.signa_pa }}
                </div>
            </div>
            <div class="mention" *ngIf="!period.tut">
                <div class="ml-1 mt-2 signature prof">
                    {{ period.signa_di }}
                </div>
                <div class="mt-2 signature parent mr-4">
                    {{ period.signa_pa }}
                </div>
            </div>
            <div class="mt-4 signature direct" *ngIf="period.tut">
                {{ period.signa_di }}
            </div>
        </div>
    </div>

</div>
